// removed by extract-text-webpack-plugin
module.exports = {"container":"XvkJi","arrow":"sT67e","page":"_325wI","active":"_1Jknx"};


//////////////////
// WEBPACK FOOTER
// ./app/components/pagination-regular/pagination-regular.scss
// module id = 1544
// module chunks = 0